"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _DownloadLinkBox = _interopRequireDefault(require("../DownloadLinkBox/DownloadLinkBox"));
var _SIASearch = require("./SIASearch");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const PagesResults = _ref => {
  let {
    text,
    pages,
    lang,
    translate
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "pages sia-border-01-bottom sia-margin-02-bottom"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-text-03  sia-margin-03-bottom"
  }, translate('cms.search.pages')), pages.map(el => {
    const lead = (0, _SIASearch.setHighlightText)(el.sia_page_lead, text);
    const title = `${el.title}${el.section_name ? ` / ${el.section_name}` : ''}`;
    const original_url = `${el.alias}${el.section ? `#${el.section}` : ''}`;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "sia-margin-01-bottom",
      key: original_url
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "sia-text-10 sia-margin-01-bottom",
      dangerouslySetInnerHTML: {
        __html: lead
      }
    }), /*#__PURE__*/_react.default.createElement(_DownloadLinkBox.default, {
      items: [{
        link: {
          original_url,
          title
        }
      }],
      lang: lang
    }));
  }));
};
var _default = exports.default = PagesResults;